import { SegmentRuleOperator } from "sharedTypes"
import { FilterFieldConfig } from "./types"

// Keeps chip.operator in sync with chip.values.length: scalar ops (eq/ne)
// for 0–1 values, array ops (in/has_all/...) for ≥2 on multiSelect fields.
export const normalizeOperator = (
  operator: SegmentRuleOperator,
  valueCount: number,
  multiSelect: boolean,
): SegmentRuleOperator => {
  if (valueCount >= 2) {
    if (!multiSelect) return operator
    if (operator === "eq") return "in"
    if (operator === "ne") return "not_in"
  } else {
    if (operator === "in" || operator === "has_all") return "eq"
    if (operator === "not_in" || operator === "not_has_all") return "ne"
  }

  return operator
}

export const operatorLabel = (
  operator: SegmentRuleOperator,
  valueCount: number,
  config: FilterFieldConfig,
): string => {
  const effective = normalizeOperator(operator, valueCount, !!config.multiSelect)

  if (config.multiValuePerGuest && valueCount >= 2) {
    if (effective === "in") return "include any of"
    if (effective === "has_all") return "include all of"
    if (effective === "not_in") return "exclude if any of"
    if (effective === "not_has_all") return "exclude if all of"
  }
  if (config.multiSelect && valueCount >= 2) {
    if (effective === "eq" || effective === "in") return "is any of"
    if (effective === "ne" || effective === "not_in") return "is not"
  }
  if (config.multiValuePerGuest) {
    if (effective === "eq") return "include"
    if (effective === "ne") return "do not include"
  }

  return config.operators.find((o) => o.value === effective)?.label ?? effective
}
